export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-unplan/[id]/+page.svelte";